import {
    doResultListUpdate
} from './_doResultListUpdate';


export var updatePageNumber = (pageNum, pageSize) => {
    var newBeginIndex = (pageNum - 1) * pageSize;
    if (newBeginIndex < 0) newBeginIndex = 0;
    $("#beginIndex").val(newBeginIndex);
    doResultListUpdate();


};
